<div class="flex flex-col items-center justify-center gap-5 p-3 w-[400px] h-[200px] rounded-md bg-white shadow-sm">
    <div class="flex items-center justify-center p-1 rounded-full border select-active">
        <span class="material-icons text-4xl orange-text">
            {{ dialogIcon }}
        </span>
    </div>
    <div class="px-7 text-center flex justify-center">
        <h3 class="text-lg font-semibold leading-snug break-words whitespace-normal"
            [innerHTML]="description">
        </h3>
    </div>
    
    @if(enableDisplayAction && actions.length > 0){
        <div class="flex gap-2 justify-end">
            @for(action of actions; track action.label) {
                <button 
                    type="button"
                    [class]="action.class || 'custom-btn login-bg px-4 py-2'"
                    (click)="onActionClick(action)"
                >
                    {{ action.label }}
                </button>
            }
        </div>
    }
</div>